import React from "react";

import "./auth.css";

function Auth(props) {
  return <section className="auth-form page">{props.children}</section>;
}

export default Auth;
